import styled from 'styled-components';

const SortByOptionsGroup = styled.div`
  position: absolute;
  width: 225px;
  display: flex;
  flex-direction: column;
  z-index: 4;
`;
export default SortByOptionsGroup;
